import { Link, List, TreeView } from '@farol-ds/react'

import { LoadMotionDebugInfoQuery } from './__generated__/debug-info.graphql'

const SCHEME = { GCS: 'gs', S3: 's3' } as const

export const formatAttachmentUrl = (
  attachment: NonNullable<LoadMotionDebugInfoQuery['root']['document']>['attachment']
) => {
  if (!attachment) {
    return null
  }
  const scheme = SCHEME[attachment.storage as keyof typeof SCHEME] || SCHEME.GCS
  return `${scheme}://${attachment.bucket}/${attachment.key}`
}

const renderJson = (data: any, nodeId = '') => {
  if (!data) {
    return null
  }

  const nodeIdPrefix = nodeId ? `${nodeId}.` : ''

  return (
    <>
      {Object.keys(data).map((key, index) => (
        <TreeView.Item key={key} label={key} nodeId={`${nodeIdPrefix}${index}`}>
          {renderJsonItem(data[key], `${nodeIdPrefix}${index}`)}
        </TreeView.Item>
      ))}
    </>
  )
}

const renderJsonItem = (value: any, nodeId: string) => {
  const childNodeId = `${nodeId}.0`

  switch (typeof value) {
    case 'object':
      return renderJson(value, nodeId)
    case 'string':
      return <TreeView.Item label={value} nodeId={childNodeId} />
    default:
      return <TreeView.Item label={JSON.stringify(value)} nodeId={childNodeId} />
  }
}

export const renderMetadata = (metadata: any) => {
  if (!metadata) {
    return null
  }

  return <TreeView>{renderJson(metadata)}</TreeView>
}

export const renderPdfInfo = (attachmentUrl: string | null) => {
  if (!attachmentUrl) {
    return null
  }

  return (
    <List unstyled={false}>
      <List.Item>
        <Link href={`https://leaky.apps.jusbr.com/file?link=${attachmentUrl}`} target="_blank">
          Original PDF
        </Link>
      </List.Item>
      <List.Item>
        <Link
          href={`https://tomahawk.apps.jusbr.com/convert?file=${attachmentUrl}&image_options=placeholder`}
          target="_blank"
        >
          Converted HTML
        </Link>
      </List.Item>
      <List.Item>
        <Link href={`https://tomahawk.apps.jusbr.com/debug?file=${attachmentUrl}`} target="_blank">
          PDF debugger
        </Link>
      </List.Item>
    </List>
  )
}
